import { CircularProgress } from '@material-ui/core';
import { getMerchantStructureByMerchantId, UserType } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { AdminAgentCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Agent/AdminAgentCard/AdminAgentCard';
import { MerchantAgentCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Agent/MerchantAgentCard/MerchantAgentCard';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useCache } from '@/hooks/requests/useCache';
import { useUser } from '@/hooks/useUser';

interface AgentCardProps {
  agentId: string;
  merchantId: string;
}

export const AgentCard = ({ agentId, merchantId }: AgentCardProps) => {
  const { userEntity } = useUser();

  const { data } = useCache(getMerchantStructureByMerchantId, {
    merchantId,
  });

  const [merchantStructure, setMerchantStructure] = useState<MerchantStructureEntity | undefined>(undefined);

  useEffect(() => {
    if (data && !merchantStructure) {
      setMerchantStructure(MerchantStructureEntity.create({ merchantStructure: data, agentId }));
    }
  }, [data]);

  if (!merchantStructure || !userEntity) {
    return <CircularProgress size={16} color={'secondary'} />;
  }

  if (userEntity.hasUserType([UserType.ADMIN, UserType.SUPER_ADMIN])) {
    return <AdminAgentCard merchantStructure={merchantStructure} />;
  }

  return <MerchantAgentCard merchantStructure={merchantStructure} />;
};
